import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row full-width" }
const _hoisted_2 = { class: "col-12" }

import { api } from '@/utils';
import { plainToInstance } from 'class-transformer';
import { ref } from 'vue';
import { Report } from '@/models/report';
import exportFile from 'quasar/src/utils/export-file.js';import useQuasar from 'quasar/src/composables/use-quasar.js';;


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const quasar = useQuasar();

const reports = ref<Report[]>([]);

const tableColumns = [
  {
    name: 'user',
    required: true,
    label: 'Usuário',
    align: 'left',
    field: (row: Report): string => row.user?.name || '-',
    sortable: true,
  },
  {
    name: 'regional',
    required: true,
    label: 'Regional',
    align: 'left',
    field: (row: Report): number => row.user?.regional,
    sortable: true,
  },
  {
    name: 'region',
    required: true,
    label: 'Região',
    align: 'left',
    field: (row: Report): number => row.user?.region,
    sortable: true,
  },
  {
    name: 'createdAt',
    required: true,
    label: 'Data de criação',
    align: 'center',
    field: (row: Report): string => row.createdAt.format('L'),
    sortable: true,
  },
  {
    name: 'farmer',
    required: true,
    label: 'Amostra',
    align: 'left',
    field: (row: Report): string => row.crop?.name || '-',
    sortable: true,
  },
  {
    name: 'farmer',
    required: true,
    label: 'Cliente',
    align: 'left',
    field: (row: Report): string => row.farmer,
    sortable: true,
  },
];

const getReports = () => {
  quasar.loading.show();

  api
    .get('report', { params: { relations: 'crop,user' } })
    .then((response) => {

      console.log("testes: ");
      console.log(response.data);

      quasar.loading.hide();

      reports.value = plainToInstance(Report, response.data);
    })
    .catch((error) => {
      quasar.notify({
        type: 'negative',
        message: 'Erro ao obter informações dos testes.',
      });

      quasar.loading.hide();

      console.log('Erro ao obter informações dos testes.', error.response);
    });

};

const init = () => {
  getReports();
};

init();

function wrapCsvValue (val, formatFn, row) {
  let formatted = formatFn !== void 0
    ? formatFn(val, row)
    : val

  formatted = formatted === void 0 || formatted === null
    ? ''
    : String(formatted)

  formatted = formatted.split('"').join('""')

  return `"${formatted}"`
}

const exportTableXLSX = () => {
  window.open(api.defaults.baseURL + "/report?relations=crop,user&export=1&_token=" + localStorage.getItem('token'), "_blank");
}

const exportTable = () => {
        const content = [tableColumns.map(col => wrapCsvValue(col.label))].concat(
          reports.value.map(row => tableColumns.map(col => wrapCsvValue(
            typeof col.field === 'function'
              ? col.field(row)
              : row[ col.field === void 0 ? col.name : col.field ],
            col.format,
            row
          )).join(','))
        ).join('\r\n')

        const status = exportFile(
          'relatorio-de-testes.csv',
          content,
          'text/csv'
        )

        if (status !== true) {
          quasar.notify({
            message: 'O seu navegador negou o download!',
            color: 'negative',
            icon: 'warning'
          })
        }
      }


return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_table, {
        title: "Lista de testes",
        rows: reports.value,
        "row-key": "id",
        columns: tableColumns,
        "rows-per-page-options": [10, 50, 100, 200, 0],
        class: ""
      }, {
        "top-right": _withCtx(() => [
          _createVNode(_component_q_btn, {
            class: "q-mr-sm",
            color: "primary",
            "icon-right": "archive",
            label: "Exportar em XLSX",
            "no-caps": "",
            onClick: exportTableXLSX
          }),
          _createVNode(_component_q_btn, {
            color: "primary",
            "icon-right": "archive",
            label: "Exportar em CSV",
            "no-caps": "",
            onClick: exportTable
          })
        ]),
        "body-cell-actions": _withCtx((props) => [
          _createVNode(_component_q_td, { props: props }, null, 8, ["props"])
        ]),
        _: 1
      }, 8, ["rows"])
    ])
  ]))
}
}

})